var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 2.66634V10.6663C3.33301 11.02 3.47348 11.3591 3.72353 11.6092C3.97358 11.8592 4.31272 11.9997 4.66634 11.9997H9.99967C10.3533 11.9997 10.6924 11.8592 10.9425 11.6092C11.1925 11.3591 11.333 11.02 11.333 10.6663V4.82767C11.333 4.65005 11.2975 4.47422 11.2286 4.3105C11.1596 4.14679 11.0587 3.9985 10.9317 3.87434L8.72167 1.71301C8.47258 1.46945 8.13805 1.33305 7.78967 1.33301H4.66634C4.31272 1.33301 3.97358 1.47348 3.72353 1.72353C3.47348 1.97358 3.33301 2.31272 3.33301 2.66634V2.66634Z",
    stroke: "#7B7B7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 11.9994V13.3327C8.6665 13.6863 8.52603 14.0254 8.27598 14.2755C8.02593 14.5255 7.68679 14.666 7.33317 14.666H1.99984C1.64622 14.666 1.30708 14.5255 1.05703 14.2755C0.80698 14.0254 0.666504 13.6863 0.666504 13.3327V5.99935C0.666504 5.64573 0.80698 5.30659 1.05703 5.05654C1.30708 4.80649 1.64622 4.66602 1.99984 4.66602H3.33317",
    stroke: "#7B7B7B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.39febf55.svg";
export { ForwardRef as ReactComponent };